<mat-toolbar color="primary">
  <mat-toolbar-row class="app-toolbar">
    <span i18n>Adaptive Service Admin Console</span>
    <span class="right-menu"> </span>

    <mat-menu #loginMenu="matMenu">
      <button mat-menu-item (click)="signOut()" i18n>Logout</button>
      <mat-divider />
      <br />
      <div class="flex-row space-evenly-center">
        @for (language of languageList; track language) {
        <a href="/{{ language.code }}/">
          <button mat-menu-item>
            <img
              [ngSrc]="language.path"
              alt="{{ language.path }}"
              width="20"
              height="15"
              style="border-radius: 2px; border: 1px solid lightblue"
            />
            {{ language.label }}
          </button>
        </a>
        }
      </div>
      <br />
      <mat-divider />
      <div class="app-right-menu-field">
        <span i18n>Version:</span> {{ versionNumber }}
      </div>
    </mat-menu>
    <button matButton [matMenuTriggerFor]="loginMenu">
      {{ userName }}
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<router-outlet />

<app-loader />
